<template>
  <div
    class="relative flex h-[90%] min-h-[30rem] overflow-y-auto w-full items-center justify-center"
  >
    <div
      class="absolute z-50 flex h-full w-[90%] rounded-lg bg-[#21212c] p-2 transition-all duration-1000"
    >
      <div class="flex h-full w-full flex-col gap-4">
        <SquadName
          :title="$t('squad_name')"
          v-model="squadNameSelection"
          placeholder="NAME YOUR SQUAD"
          @input="updateForm"
          :locale="locale"
        />
        <div class="h-[0.1vh] w-full rounded-lg bg-zinc-500"></div>
        <FormationSelection
          :title="$t('whats_your_formation')"
          v-model="selectedFormation"
          @update:modelValue="updateForm"
          :options="formationOptions"
          :locale="locale"
        />
        <div class="h-[0.1vh] w-full rounded-lg bg-zinc-500"></div>
        <StadiumSelection
          :title="$t('where_would_you_play')"
          v-model="stadiumSelection"
          @update:modelValue="updateForm"
          :stadiums="stadiums"
          :isTransitioning="isTransitioning"
          :locale="locale"
        />
        <div class="flex h-[10%] w-full items-center justify-center">
          <button
            @click="handleScreenshot"
            class="h-[85%] w-[90%] rounded-xl bg-saudi-purple text-[4vw] md:text-[1.2vw] font-bold text-white hover:bg-[#cf70cf]"
            :disabled="localBlockButton"
          >
            {{ $t("save_and_share") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from "vue";
import SquadName from "./SquadName.vue";
import FormationSelection from "./FormationSelection.vue";
import StadiumSelection from "./StadiumSelection.vue";
import { useI18n } from "vue-i18n";

const { locale } = useI18n();
const emit = defineEmits([
  "updateFormation",
  "updateSquadName",
  "updateStadium",
  "handleScreenshot",
  "toggleSidebar",
  "updateBlockButton",
]);

const props = defineProps({
  formation: String,
  squadName: String,
  stadiums: Object,
  isTransitioning: Boolean,
  selectedStadiumId: Number,
  showSidebar: Boolean,
  isMobile: Boolean,
  blockButton: Boolean,
});

const selectedFormation = ref(props.formation);
const squadNameSelection = ref(props.squadName);
const stadiumSelection = ref(props.selectedStadiumId);

const formationOptions = [
  { id: 1, value: "343", label: "3-4-3" },
  { id: 2, value: "352", label: "3-5-2" },
  { id: 3, value: "433", label: "4-3-3" },
  { id: 4, value: "442", label: "4-4-2" },
  { id: 5, value: "451", label: "4-5-1" },
  { id: 6, value: "451 2", label: "4-2-3-1" },
  { id: 7, value: "451 3", label: "4-1-4-1" },
  { id: 8, value: "442 2", label: "4-1-2-1-2" },
  { id: 9, value: "532", label: "5-3-2" },
  { id: 10, value: "523", label: "5-2-3" },
];

const localBlockButton = ref(props.blockButton);

watch(
  () => props.blockButton,
  (newVal) => {
    localBlockButton.value = newVal;
  }
);

const handleScreenshot = () => {
  localBlockButton.value = true;
  emit("updateBlockButton", true);
  emit("toggleSidebar");

  if (typeof window.gtag === "function") {
    window.gtag("event", "save_and_screenshot", {
      value: 1,
    });
  }

  const resetButtonState = () => {
    localBlockButton.value = false;
    emit("updateBlockButton", false);
  };

  if (props.isMobile) {
    setTimeout(() => {
      emit("handleScreenshot");
      setTimeout(resetButtonState, 3000);
    }, 1000);
  } else {
    emit("handleScreenshot");
    setTimeout(resetButtonState, 3000);
  }
};

const updateForm = () => {
  emit("updateFormation", selectedFormation.value);
  emit("updateSquadName", squadNameSelection.value);
  emit("updateStadium", stadiumSelection.value);
};
</script>